<template>
  <div class="document">
    文档还没做
  </div>
</template>

<script>
/**
 * @description 文档
 * @created 2024/04/19 14:45:23
 */
export default {
  meta: {
    title: "文档"
  },
  name: "Document",
  data() {
    return {

    }
  },
  mounted() {

  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
.document {
  height: 100%;
  @include flex();
}
</style>
